export function loadScript(src) {
  return new Promise(function (resolve, reject) {
    const s = document.createElement('script')
    s.src = src
    s.onload = resolve
    s.onerror = reject
    s.crossorigin = true
    document.head.appendChild(s)
  })
}

export function loadScriptOnce(src) {
  return new Promise(function (resolve, reject) {
    const list = document.getElementsByTagName('script')
    const arrayOfScripts = Array.prototype.slice.call(list).map(el => el.src)

    if (~arrayOfScripts.findIndex(el => el.match(src))) {
      return resolve()
    }

    const s = document.createElement('script')
    s.src = src
    s.onload = resolve
    s.onerror = reject
    s.crossorigin = true
    document.head.appendChild(s)
  })
}
